export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_INIT = 'LOGIN_INIT';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const OTP_SEND_SUCCESS = 'OTP_SEND_SUCCESS';
export const OTP_SEND_INIT = 'OTP_SEND_INIT';
export const OTP_SEND_FAIL = 'OTP_SEND_FAIL';

// user

export const GET_DASHBOARD_INIT = 'GET_DASHBOARD_INIT';
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';
export const GET_DASHBOARD_FAIL = 'GET_DASHBOARD_FAIL';

export const GET_DASHBOARD_EMP_INIT = 'GET_DASHBOARD_EMP_INIT';
export const GET_DASHBOARD_EMP_SUCCESS = 'GET_DASHBOARD_EMP_SUCCESS';
export const GET_DASHBOARD_EMP_FAIL = 'GET_DASHBOARD_EMP_FAIL';

export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_INIT = 'GET_USER_INIT';
export const GET_USER_FAIL = 'GET_USER_FAIL';

export const GET_VIEW_USER_SUCCESS = 'GET_VIEW_USER_SUCCESS';
export const GET_VIEW_USER_FAIL = 'GET_VIEW_USER_FAIL';
export const GET_VIEW_USER_INIT = 'GET_VIEW_USER_INIT';

export const SEARCH_USER_SUCCESS = 'SEARCH_USER_SUCCESS';
export const SEARCH_USER_INIT = 'SEARCH_USER_INIT';
export const SEARCH_USER_FAIL = 'SEARCH_USER_FAIL';

export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_INIT = 'ADD_USER_INIT';
export const ADD_USER_FAIL = 'ADD_USER_FAIL';

export const ADD_USER_DYNAMIC_SUCCESS = 'ADD_USER_DYNAMIC_SUCCESS';
export const ADD_USER_DYNAMIC_INIT = 'ADD_USER_DYNAMIC_INIT';
export const ADD_USER_DYNAMIC_FAIL = 'ADD_USER_DYNAMIC_FAIL';

export const GET_SINGLE_USER_SUCCESS = 'GET_SINGLE_USER_SUCCESS';
export const GET_SINGLE_USER_INIT = 'GET_SINGLE_USER_INIT';
export const GET_SINGLE_USER_FAIL = 'GET_SINGLE_USER_FAIL';

export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_INIT = 'EDIT_USER_INIT';
export const EDIT_USER_FAIL = 'EDIT_USER_FAIL';

export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_INIT = 'DELETE_USER_INIT';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

// Admin

export const GET_ADMIN_SUCCESS = 'GET_ADMIN_SUCCESS';
export const GET_ADMIN_INIT = 'GET_ADMIN_INIT';
export const GET_ADMIN_FAIL = 'GET_ADMIN_FAIL';

export const UPDATE_ADMIN_SUCCESS = 'UPDATE_ADMIN_SUCCESS';
export const UPDATE_ADMIN_INIT = 'UPDATE_ADMIN_INIT';
export const UPDATE_ADMIN_FAIL = 'UPDATE_ADMIN_FAIL';

// employer

export const GET_EMPLOYER_SUCCESS = 'GET_EMPLOYER_SUCCESS';
export const GET_EMPLOYER_INIT = 'GET_EMPLOYER_INIT';
export const GET_EMPLOYER_FAIL = 'GET_EMPLOYER_FAIL';

export const SEARCH_EMPLOYER_SUCCESS = 'SEARCH_EMPLOYER_SUCCESS';
export const SEARCH_EMPLOYER_INIT = 'SEARCH_EMPLOYER_INIT';
export const SEARCH_EMPLOYER_FAIL = 'SEARCH_EMPLOYER_FAIL';

export const ADD_EMPLOYER_SUCCESS = 'ADD_EMPLOYER_SUCCESS';
export const ADD_EMPLOYER_INIT = 'ADD_EMPLOYER_INIT';
export const ADD_EMPLOYER_FAIL = 'ADD_EMPLOYER_FAIL';

export const GET_SINGLE_EMPLOYER_SUCCESS = 'GET_SINGLE_EMPLOYER_SUCCESS';
export const GET_SINGLE_EMPLOYER_INIT = 'GET_SINGLE_EMPLOYER_INIT';
export const GET_SINGLE_EMPLOYER_FAIL = 'GET_SINGLE_EMPLOYER_FAIL';

export const EDIT_EMPLOYER_SUCCESS = 'EDIT_EMPLOYER_SUCCESS';
export const EDIT_EMPLOYER_INIT = 'EDIT_EMPLOYER_INIT';
export const EDIT_EMPLOYER_FAIL = 'EDIT_EMPLOYER_FAIL';

export const DELETE_EMPLOYER_SUCCESS = 'DELETE_EMPLOYER_SUCCESS';
export const DELETE_EMPLOYER_INIT = 'DELETE_EMPLOYER_INIT';
export const DELETE_EMPLOYER_FAIL = 'DELETE_EMPLOYER_FAIL';

// employee

export const GET_EMPLOYEE_SUCCESS = 'GET_EMPLOYEE_SUCCESS';
export const GET_EMPLOYEE_INIT = 'GET_EMPLOYEE_INIT';
export const GET_EMPLOYEE_FAIL = 'GET_EMPLOYEE_FAIL';

export const SEARCH_EMPLOYEE_SUCCESS = 'SEARCH_EMPLOYEE_SUCCESS';
export const SEARCH_EMPLOYEE_INIT = 'SEARCH_EMPLOYEE_INIT';
export const SEARCH_EMPLOYEE_FAIL = 'SEARCH_EMPLOYEE_FAIL';

export const ADD_EMPLOYEE_SALARY_SUCCESS = 'ADD_EMPLOYEE_SALARY_SUCCESS';
export const ADD_EMPLOYEE_SALARY_INIT = 'ADD_EMPLOYEE_SALARY_INIT';
export const ADD_EMPLOYEE_SALARY_FAIL = 'ADD_EMPLOYEE_SALARY_FAIL';

export const GET_SINGLE_EMPLOYEE_SUCCESS = 'GET_SINGLE_EMPLOYEE_SUCCESS';
export const GET_SINGLE_EMPLOYEE_INIT = 'GET_SINGLE_EMPLOYEE_INIT';
export const GET_SINGLE_EMPLOYEE_FAIL = 'GET_SINGLE_EMPLOYEE_FAIL';

export const GET_STATIC_EMPLOYEE_SUCCESS = 'GET_STATIC_EMPLOYEE_SUCCESS';
export const GET_STATIC_EMPLOYEE_INIT = 'GET_STATIC_EMPLOYEE_INIT';
export const GET_STATIC_EMPLOYEE_FAIL = 'GET_STATIC_EMPLOYEE_FAIL';

export const GET_SINGLE_STATIC_EMPLOYEE_SUCCESS = 'GET_SINGLE_STATIC_EMPLOYEE_SUCCESS';
export const GET_SINGLE_STATIC_EMPLOYEE_INIT = 'GET_SINGLE_STATIC_EMPLOYEE_INIT';
export const GET_SINGLE_STATIC_EMPLOYEE_FAIL = 'GET_SINGLE_STATIC_EMPLOYEE_FAIL';

export const EDIT_STATIC_EMPLOYEE_SUCCESS = 'EDIT_SINGLE_STATIC_SUCCESS';
export const EDIT_STATIC_EMPLOYEE_INIT = 'EDIT_SINGLE_STATIC_INIT';
export const EDIT_STATIC_EMPLOYEE_FAIL = 'EDIT_STATIC_EMPLOYEE_FAIL';

export const EDIT_EMPLOYEE_SUCCESS = 'EDIT_EMPLOYEE_SUCCESS';
export const EDIT_EMPLOYEE_INIT = 'EDIT_EMPLOYEE_INIT';
export const EDIT_EMPLOYEE_FAIL = 'EDIT_EMPLOYEE_FAIL';

export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';
export const DELETE_EMPLOYEE_INIT = 'DELETE_EMPLOYEE_INIT';
export const DELETE_EMPLOYEE_FAIL = 'DELETE_EMPLOYEE_FAIL';

// blog

export const GET_BLOG_SUCCESS = 'GET_BLOG_SUCCESS';
export const GET_BLOG_INIT = 'GET_BLOG_INIT';
export const GET_BLOG_FAIL = 'GET_BLOG_FAIL';

export const GET_SINGLE_BLOG_SUCCESS = 'GET_SINGLE_BLOG_SUCCESS';
export const GET_SINGLE_BLOG_INIT = 'GET_SINGLE_BLOG_INIT';
export const GET_SINGLE_BLOG_FAIL = 'GET_SINGLE_BLOG_FAIL';

export const ADD_BLOG_SUCCESS = 'ADD_BLOG_SUCCESS';
export const ADD_BLOG_INIT = 'ADD_BLOG_INIT';
export const ADD_BLOG_FAIL = 'ADD_BLOG_FAIL';

export const EDIT_BLOG_SUCCESS = 'EDIT_BLOG_SUCCESS';
export const EDIT_BLOG_INIT = 'EDIT_BLOG_INIT';
export const EDIT_BLOG_FAIL = 'EDIT_BLOG_FAIL';

export const DELETE_BLOG_SUCCESS = 'DELETE_BLOG_SUCCESS';
export const DELETE_BLOG_INIT = 'DELETE_BLOG_INIT';
export const DELETE_BLOG_FAIL = 'DELETE_BLOG_FAIL';

// ticket

export const GET_TICKET_SUCCESS = 'GET_TICKET_SUCCESS';
export const GET_TICKET_INIT = 'GET_TICKET_INIT';
export const GET_TICKET_FAIL = 'GET_TICKET_FAIL';

export const UPDATE_TICKET_SUCCESS = 'UPDATE_TICKET_SUCCESS';
export const UPDATE_TICKET_INIT = 'UPDATE_TICKET_INIT';
export const UPDATE_TICKET_FAIL = 'UPDATE_TICKET_FAIL';

export const GET_ONE_TICKET_SUCCESS = 'GET_ONE_TICKET_SUCCESS';
export const GET_ONE_TICKET_INIT = 'GET_ONE_TICKET_INIT';
export const GET_ONE_TICKET_FAIL = 'GET_ONE_TICKET_FAIL';

export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_INIT = 'ADD_COMMENT_INIT';
export const ADD_COMMENT_FAIL = 'ADD_COMMENT_FAIL';

export const GET_SINGLE_TICKET_SUCCESS = 'GET_SINGLE_TICKET_SUCCESS';
export const GET_SINGLE_TICKET_INIT = 'GET_SINGLE_TICKET_INIT';
export const GET_SINGLE_TICKET_FAIL = 'GET_SINGLE_TICKET_FAIL';

// transaction

export const GET_TRANSACTION_SUCCESS = 'GET_TRANSACTION_SUCCESS';
export const GET_TRANSACTION_INIT = 'GET_TRANSACTION_INIT';
export const GET_TRANSACTION_FAIL = 'GET_TRANSACTION_FAIL';

export const GET_SINGLE_TRANSACTION_SUCCESS = 'GET_SINGLE_TRANSACTION_SUCCESS';
export const GET_SINGLE_TRANSACTION_INIT = 'GET_SINGLE_TRANSACTION_INIT';
export const GET_SINGLE_TRANSACTION_FAIL = 'GET_SINGLE_TRANSACTION_FAIL';
